<main id="main-content" tabindex="-1" aria-label="Courses">
  <div class="container md:px-20 px-0 pt-10">
    <prism-title additionalClasses="text-4xl" title="Courses"></prism-title>
    @if (courseList?.length == 0) {
      <p class="ml-[100px]">No courses available.</p>
    }
    @else {
      <prism-card-list [dataList]="courseList" (cardClick)="viewCourse($event)">
      </prism-card-list>
    }
  </div>
</main>
